import {authApi} from './api.service';

export async function getLoginMethod(email: string): Promise<'default' | 'microsoft'> {
    const res = await authApi.post('api/v2/login-method', { email }, { headers: { 'No-Loader': true } });
    return res.data.path;
}
